import { toFormat } from 'core/classes/helpers/DateHelper'

export const changeDateTime = (onChange: (value: string) => void) => (value: Date) => {
  onChange(toFormat(value, 'YYYY-MM-DDTHH:mm:ss'))
}
